import {Box, Typography} from "@mui/material";

export interface StatTileProps {
    value: number | null | undefined;
    label: string;
}

export default function StatTile(props: Readonly<StatTileProps>) {
    const {value, label} = props;
    const displayValue = value == null ? "—" : value.toLocaleString("cs-CZ");

    return (
        <Box data-testid="stat-tile"
             sx={{
                 height: "100%",
                 p: 2,
                 border: "1px solid",
                 borderColor: "divider",
                 borderRadius: 1,
                 textAlign: "center",
             }}>
            <Typography variant="h4" component="div">{displayValue}</Typography>
            <Typography variant="body2" color="text.secondary">{label}</Typography>
        </Box>
    );
}
